import styled from 'styled-components';

const RowContainer = styled.div`
  align-items: ${props => (props.align === 'start' ? 'flex-start' : (props.align === 'end' ? 'flex-end' : 'center'))};
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
  width: 100%;
`;

export default RowContainer;